module.exports = __webpack_public_path__ + "img/ref1.6b0594ea.png";